import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFoundPage = () => {
  return (
    <>
      <SEO 
        title="Page Not Found - Local Business Heroes"
        description="The page you're looking for doesn't exist. Explore our features, pricing, and industry solutions."
        noindex={true}
      />
      
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0E163B 0%, #1a2654 100%)',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div style={{ maxWidth: '700px', textAlign: 'center' }}>
          <div style={{
            fontSize: '80px',
            marginBottom: '20px',
            animation: 'float 3s ease-in-out infinite'
          }}>
            🤔
          </div>
          
          <div style={{
            fontSize: '120px',
            fontWeight: '700',
            background: 'linear-gradient(135deg, #FF5A3D 0%, #FF8C42 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: '20px',
            lineHeight: '1'
          }}>
            404
          </div>
          
          <h1 style={{ fontSize: '36px', marginBottom: '15px' }}>
            Oops! Page Not Found
          </h1>
          
          <p style={{
            fontSize: '18px',
            opacity: '0.9',
            marginBottom: '40px',
            lineHeight: '1.6'
          }}>
            Looks like this page decided to take an unexpected day off. 
            Don't worry though – we've got plenty of other great pages waiting for you!
          </p>
          
          <div style={{
            display: 'flex',
            gap: '15px',
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginBottom: '50px'
          }}>
            <Link 
              to="/" 
              style={{
                padding: '15px 30px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '16px',
                background: 'linear-gradient(135deg, #FF5A3D 0%, #FF8C42 100%)',
                color: 'white',
                transition: 'all 0.3s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              🏠 Back to Home
            </Link>
            
            <Link 
              to="/pricing" 
              style={{
                padding: '15px 30px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '16px',
                background: 'rgba(255, 255, 255, 0.1)',
                color: 'white',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              💳 View Pricing
            </Link>
          </div>
          
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            padding: '30px',
            marginTop: '40px'
          }}>
            <h2 style={{ fontSize: '20px', marginBottom: '20px', opacity: '0.9' }}>
              Popular Pages
            </h2>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
              gap: '15px'
            }}>
              <Link to="/" style={{
                background: 'rgba(255, 255, 255, 0.08)',
                padding: '15px',
                borderRadius: '8px',
                textDecoration: 'none',
                color: 'white',
                transition: 'all 0.3s',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '24px' }}>🏠</span>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>Home</span>
              </Link>
              
              <Link to="/pricing" style={{
                background: 'rgba(255, 255, 255, 0.08)',
                padding: '15px',
                borderRadius: '8px',
                textDecoration: 'none',
                color: 'white',
                transition: 'all 0.3s',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '24px' }}>💳</span>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>Pricing</span>
              </Link>
              
              <Link to="/features" style={{
                background: 'rgba(255, 255, 255, 0.08)',
                padding: '15px',
                borderRadius: '8px',
                textDecoration: 'none',
                color: 'white',
                transition: 'all 0.3s',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '24px' }}>✨</span>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>Features</span>
              </Link>
              
              <Link to="/industries" style={{
                background: 'rgba(255, 255, 255, 0.08)',
                padding: '15px',
                borderRadius: '8px',
                textDecoration: 'none',
                color: 'white',
                transition: 'all 0.3s',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '24px' }}>🏢</span>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>Industries</span>
              </Link>
              
              <Link to="/blog" style={{
                background: 'rgba(255, 255, 255, 0.08)',
                padding: '15px',
                borderRadius: '8px',
                textDecoration: 'none',
                color: 'white',
                transition: 'all 0.3s',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '24px' }}>📝</span>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>Blog</span>
              </Link>
              
              <Link to="/contact" style={{
                background: 'rgba(255, 255, 255, 0.08)',
                padding: '15px',
                borderRadius: '8px',
                textDecoration: 'none',
                color: 'white',
                transition: 'all 0.3s',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '24px' }}>📧</span>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>Contact</span>
              </Link>
            </div>
          </div>
          
          <div style={{ marginTop: '40px', opacity: '0.7', fontSize: '14px' }}>
            <p>
              Need help? Email us at{' '}
              <a 
                href="mailto:support@localbusinessheroes.net" 
                style={{ color: '#FF5A3D', textDecoration: 'none' }}
              >
                support@localbusinessheroes.net
              </a>
            </p>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </>
  );
};

export default NotFoundPage;
